import { getDiscoverSchools } from '@/services/DiscoverService.js';

export default {
  async fetchDiscoverSchools(context) {
    context.commit('setLoading', true);
    context.commit('setError', null);
    try {
      const data = await getDiscoverSchools();
      context.commit('setSchools', data.data.schools);
      return data.data.schools;
    } catch (err) {
      context.commit('setError', err);
      throw err;
    } finally {
      context.commit('setLoading', false);
    }
  },
};
